<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics" ref="dashboardWidth">
    <!-- Observes page resize -->
    <resize-observer :emitOnMount="true" @notify="getDimensions"></resize-observer>

    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <div class="flex justify-end px-2">
          <vs-tooltip color="primary" text="Add Widgets" position="bottom">
            <vs-button 
              radius 
              type="filled"
              icon="add_chart"
              @click="openWidgetsSelectDialog('Add')"
            />
          </vs-tooltip>
        </div>
      </div>
    </div>

    <dashboard-cards
      :cardWidths="cardWidths"
      :allWidgetsToDisplay="allWidgetsToDisplay"
      @widget-delete="removeWidget"
      @widget-edit="editWidget"
      @generate-temp-graph="filterGraph"
    />

    <!-- Widget selection modal -->
    <div id="div-with-loading" class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup vs-con-loading__container stat_modal" v-if="widgetSelectModalShow" :class="{show: widgetSelectModalShow}">
      <div class="cstm-modal">
        <div class="header">
            <h3>{{ dialogMode }} Widget {{ cardCreationPipeline }}</h3>
            <button @click="closeWidgetsSelectDialog" class="close-modal">&times;</button>
        </div>
        <div id="widgets-selection-container" class="modal-content">
          <form-wizard class="cstm_form_wizard" :startIndex="dialogMode === 'Edit' ? 1 : 0" title="" subtitle="" stepSize="xs" color="rgb(var(--vs-primary))" @on-change="onWizardTabChange" @on-complete="createWidget">

            <!-- Tab 1 -->
            <tab-content>
              <div class="md:flex">
                <div class="flex flex-1 flex-col">
                  <h6>Select predefined widgets</h6>
                  <v-select
                    class="mt-4"
                    :options="allPredefinedWidgetList"
                    label="name"
                    placeholder="Select a widget"
                    :clearable="false"
                    :disabled="dialogMode === 'Edit'"
                    @input="enablePredefinedWidget"
                  >
                    <template v-slot:option="option">
                      {{ option.card_type }} - {{ option.name }}
                    </template>
                  </v-select>
                </div>

                <div class="vertical-divider">
                </div>

                <div class="flex flex-1 flex-col">
                  <h5 class="text-center mb-4">Choose any one card</h5>
                  <div v-for="(option, index) in createWidgetOptions" :key="index" class="text-center mb-5">
                    <vs-radio class="customRadio custom_container w-full mx-auto" v-model="createWidgetType" :vs-value="`${option.type}`">
                      <span class="material-icons-outlined icon">{{ option.icon }}</span>
                      <h6 class="my-4">{{ option.name }}</h6>
                    </vs-radio>
                  </div>
                </div>
              </div>
            </tab-content>

            <!-- Tab 2 -->
            <tab-content>
                <div v-if="createWidgetType === 'graph'">
                  <h5 class="mb-4 text-center">Choose any one graph</h5>
                  <div class="flex flex-wrap justify-evenly">
                    <div v-for="(option, index) in graphTypeOptions" :key="index" class="each_graph_holder my-2">
                      <vs-radio class="customRadio custom_container w-full mx-auto" v-model="graphCreationPayload.graph_type" :vs-value="`${option.type}`">
                        <span class="material-icons-outlined icon">{{ option.icon }}</span>
                        <h6 class="my-4">{{ option.name }}</h6>
                      </vs-radio>
                    </div>
                  </div>
                </div>

                <div v-if="createWidgetType === 'stat'" class="flex flex-1 flex-col">
                  <vs-row>
                    <vs-col vs-lg="6" vs-sm="12">
                      <div class="p-1">
                        <h6>Select relevant module</h6>
                        <v-select
                          class="mt-4"
                          v-model="statCreationPayload.module_id"
                          :options="moduleListForStats"
                          :reduce="option => option.platform_modules_id"
                          label="module_name"
                          :clearable="false"
                          @input="getModuleStatSettings()"
                        >
                        </v-select>
                      </div>
                    </vs-col>

                    <vs-col vs-lg="6" vs-sm="12">
                      <div class="p-1">
                        <h6>Select Time Period</h6>
                        <v-select
                          class="mt-4"
                          v-model="statCreationPayload.time_period"
                          :options="dateOptions"
                          :reduce="option => option.id"
                          label="name"
                          :clearable="false"
                        >
                        </v-select>
                      </div>
                    </vs-col>
                  </vs-row>

                  <!-- <pre>{{ statCreationPayload }}</pre> -->
                  <!-- <pre>{{ stats }}</pre> -->

                  <div v-if="stats.length > 0" class="flex flex-1 flex-row mb-5">
                    <vs-list>
                      <vs-list-item 
                        v-for="(stat, idx) in stats" 
                        :key="idx"
                        :title="stat.option_name"
                      >
                        <template slot="avatar">
                          <vs-radio v-model="statCreationPayload.is_enabled" :vs-value="stat.id" @change="onChangeOption" />
                        </template>

                          <div v-if="statCreationPayload.is_enabled === stat.id && stat.has_dropdown && stat.no_of_dropdown === 1">
                            
                            <v-select
                              style="min-width: 250px;"
                              placeholder="Select Options"
                              v-if="stat.has_dropdown && stat.dropdown_list.length > 0"
                              v-model="statCreationPayload.option_id"
                              :options="stat.dropdown_list"
                              label="name"
                              :reduce="option => option.id"
                              :clearable="false"
                            >
                            </v-select>
                          </div>

                          <div v-if="statCreationPayload.is_enabled === stat.id && stat.has_dropdown && stat.no_of_dropdown === 2">
                            <v-select
                              v-if="stat.dropdown_list.length > 0" 
                              v-model="statCreationPayload.parent_option_id"
                              :options="stat.dropdown_list"
                              label="name"
                              :reduce="option => option.id"
                              :clearable="false"
                              style="min-width: 250px;"
                              @input="getStatusList(stat)"
                            >
                            </v-select>

                            <v-select
                              v-if="stat.project_status_list.length > 0"
                              v-model="statCreationPayload.option_id"
                              :options="stat.project_status_list"
                              label="name"
                              :reduce="option => option.id"
                              :clearable="false"
                              style="min-width: 250px;"
                            >
                            </v-select>
                          </div>

                          <div v-if="statCreationPayload.is_enabled === stat.id && stat.has_price_range">
                            <vs-slider class="modal-slider" max="10000" v-model="statCreationPayload.price_range" />
                          </div>
                        

                      </vs-list-item>
                    </vs-list>
                  </div>
                </div>
            </tab-content>
            
            <!-- Tab 3 -->
            <tab-content>
              <div v-if="createWidgetType === 'graph'" class="flex flex-1 flex-col flex-wrap">
                <vs-row>
                  <vs-col vs-lg="6" vs-sm="12">
                    <div class="p-1">
                      <h6>Select relevant module</h6>
                      <v-select
                        class="w-full mt-1"
                        v-model="graphCreationPayload.module_id"
                        :options="platformModules"
                        :reduce="option => option.platform_modules_id"
                        label="module_name"
                        :clearable="false"
                        @input="getXAxisList()"
                      >
                      </v-select>
                    </div>
                  </vs-col>

                  <vs-col vs-lg="6" vs-sm="12">
                    <div class="p-1">
                      <h6>Select Time Period</h6>
                      <v-select
                        class="w-full mt-1"
                        v-model="graphCreationPayload.time_period"
                        :options="dateOptions"
                        :reduce="option => option.id"
                        label="name"
                        :clearable="false"
                      >
                      </v-select>
                    </div>
                  </vs-col>

                  <vs-col vs-lg="6" vs-sm="12">
                    <div class="p-1">
                      <h6>Select the X-Axis</h6>
                      <v-select
                        class="w-full mt-1"
                        v-model="graphCreationPayload.x_axis"
                        :options="xAxisList"
                        :reduce="option => option.id"
                        label="name"
                        :clearable="false"
                        @input="getYAxisList()"
                      >
                      </v-select>
                    </div>
                  </vs-col>

                  <vs-col vs-lg="6" vs-sm="12">
                    <div class="p-1">
                      <h6>Select the Y-Axis</h6>
                      <v-select
                        class="w-full mt-1"
                        v-model="graphCreationPayload.y_axis"
                        :options="yAxisList"
                        :reduce="option => option.id"
                        label="name"
                        :clearable="false"
                      >
                      </v-select>
                    </div>
                  </vs-col>
                </vs-row>
                <vs-row class="mt-2">
                  <vs-col vs-lg="4" vs-sm="12">
                    <div class="flex items-center preview-button p-1 h-full" @click="openPreviewPanel">
                      <span class="material-icons">visibility</span>
                      <span class="ml-3">Preview</span>
                    </div>
                  </vs-col>
                  <vs-col vs-lg="8" vs-sm="12">
                    <div class="md:flex items-center justify-end p-1">
                      <h6 class="mr-2">Name of the graph</h6>
                      <vs-input class="md:w-auto w-full" v-model="graphCreationPayload.card_name" />
                    </div>
                  </vs-col>
                </vs-row>
              </div>

              <div v-if="createWidgetType === 'stat'" class="flex flex-1 flex-col">
                <div class="flex flex-1 mb-6">

                  <div class="flex flex-1 items-center justify-end">
                    <h6 class="mr-5">Name of the statistics</h6>
                    <vs-input v-model="statCreationPayload.card_name" />
                  </div>
                </div>
              </div>
            </tab-content>

            <vs-button slot="prev">Back</vs-button>
            <vs-button :disabled="isNextDisabled" slot="next">Next</vs-button>
            <vs-button :disabled="isNextDisabled" slot="finish">Done</vs-button>

          </form-wizard>
        </div>
      </div>
    </div> 

    <!-- Widget preview modal -->
    <div id="div-with-loading" class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup vs-con-loading__container stat_modal preview_dashboard_modal" v-if="previewShow" :class="{show: previewShow}">
      <div class="cstm-modal">
        <div class="header">
            <h3>Preview Widget {{ cardCreationPipeline }}</h3>
            <button @click="closePreviewPanel" class="close-modal">&times;</button>
        </div>
        <div id="widgets-preview-container" class="modal-content">
          <div v-if="createWidgetType === 'graph'" class="flex flex-1 graph_preview_holder">
            <graph-card v-if="previewData" :preview="true" :graph="previewData.graph" :graphData="previewData.graph_data" />
            <div v-else class="flex flex-1 justify-center">Generating graph preview...</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import dashboardCards from './components/dashboardCards.vue'
import { dashboardMixins } from './mixins/dashboardMixins'
import { dashboardChartsMixins } from './mixins/dashboardChartsMixins'
import { dashboardStatsMixins } from './mixins/dashboardStatsMixins'
import graphCard from './components/graphCard.vue'

import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import vSelect from 'vue-select'

export default {
  mixins: [dashboardMixins, dashboardChartsMixins, dashboardStatsMixins],
  data () {
    return {
      widgetSelectModalShow: false,
      dashboardWidth: null,
      cardWidths: [
        {
          percent: 25,
          value: null
        },
        {
          percent: 50,
          value: null
        },
        {
          percent: 75,
          value: null
        },
        {
          percent: 100,
          value: null
        }
      ],
      createWidgetType: null,
      createWidgetTabIndex: null,
      createWidgetOptions: [
        { type: 'graph', name: 'Create a new graph card', icon: 'addchart' },
        { type: 'stat', name: 'Create a new stat card', icon: 'library_books' }
      ],
      graphTypeOptions: [
        { type: 'column', name: 'Column Graph', icon: 'bar_chart' },
        { type: 'bar', name: 'Bar Graph', icon: 'sort' },
        { type: 'line', name: 'Line Graph', icon: 'show_chart' },
        { type: 'pie', name: 'Pie Chart', icon: 'pie_chart_outline' },
        { type: 'radar', name: 'Radar Chart', icon: 'radar' }
      ],
      dateOptions: [
        { id: 1, name: 'Today' },
        { id: 2, name: 'Yesterday' },
        { id: 7, name: 'This Week' },
        { id: 8, name: 'Last Week' },
        { id: 3, name: 'This Month' },
        { id: 5, name: 'Last Month' },
        { id: 4, name: 'This Year' },
        { id: 9, name: 'Last Year' }
      ],
      graphCreationPayload: {
        graph_type: '',
        module_id: '',
        x_axis: '',
        y_axis: '',
        time_period: '',
        card_name: ''
      },
      statCreationPayload: {
        is_enabled: null,
        module_id: '',
        time_period: '',
        card_name: '',
        parent_option_id: null,
        option_id: null,
        price_range: [100, 500],
        value_for: 1
      },
      isNextDisabled: true,
      dialogMode: null,
      previewShow: false
    }
  },
  watch: {
    createWidgetType () {
      this.enableDisableNext()
    },
    'graphCreationPayload': {
      handler () {
        this.enableDisableNext()
      },
      deep: true
    },
    'statCreationPayload': {
      handler () {
        this.enableDisableNext()
      },
      deep: true
    }
  },
  computed: {
    cardCreationPipeline () {
      if (this.createWidgetTabIndex > 0) {
        return this.createWidgetType === 'graph' ? '- Graph' : '- Statistics' 
      }
    }
  },
  components: {
    dashboardCards,
    graphCard,
    vSelect,
    FormWizard,
    TabContent,
    WizardButton
  },
  methods: {
    openWidgetsSelectDialog (mode) {
      this.dialogMode = mode
      this.widgetSelectModalShow = true
    },
    closeWidgetsSelectDialog () {
      this.widgetSelectModalShow = false
      this.resetWidgetCreationModal()
    },
    openPreviewPanel () {
      this.previewShow = true
      this.getPreview()
    },
    closePreviewPanel () {
      this.previewShow = false
      this.previewData = null
    },
    getDimensions (data) {
      //console.log('Dimensions: ', data)
      this.dashboardWidth = data.width - 61.6
      //console.log('Dashboard Width', this.dashboardWidth)
      this.calculateWidths()
    },
    calculateWidths () {
      const calculatedWidths = this.cardWidths.map(item => {
        const pxValue = (this.dashboardWidth * item.percent) / 100

        return {
          percent: item.percent,
          value: pxValue
        }
      })

      this.cardWidths = calculatedWidths
      //console.log(this.cardWidths)
    },
    onWizardTabChange (prevIndex, nextIndex) {
      this.createWidgetTabIndex = nextIndex

      this.enableDisableNext()
    },
    onChangeOption () {
      this.statCreationPayload.parent_option_id = null
      this.statCreationPayload.option_id = null
      this.statCreationPayload.price_range = [100, 500]
    },
    enableDisableNext () {
      if (!this.createWidgetType) {
        this.isNextDisabled = true
      } else {
        this.isNextDisabled = false
      }

      if (this.createWidgetType === 'graph') {
        if (this.createWidgetTabIndex === 1) {
          if (!this.graphCreationPayload.graph_type) {
            this.isNextDisabled = true
          } else {
            this.isNextDisabled = false
          }
        } else if (this.createWidgetTabIndex === 2) {
          if (!this.graphCreationPayload.module_id || !this.graphCreationPayload.x_axis || !this.graphCreationPayload.y_axis || !this.graphCreationPayload.time_period || !this.graphCreationPayload.card_name) {
            this.isNextDisabled = true
          } else {
            this.isNextDisabled = false
          }
        }
      } else if (this.createWidgetType === 'stat') {
        if (this.createWidgetTabIndex === 1) {
          if (!this.statCreationPayload.module_id || !this.statCreationPayload.time_period) {
            this.isNextDisabled = true
          } else {
            this.isNextDisabled = false
          }
        } else if (this.createWidgetTabIndex === 2) {
          if (!this.statCreationPayload.card_name) {
            this.isNextDisabled = true
          } else {
            this.isNextDisabled = false
          }
        }
      }
    },
    resetWidgetCreationModal () {
      this.createWidgetType = null
      this.createWidgetTabIndex = null
      this.dialogMode = null
      this.graphCreationPayload = {
        graph_type: '',
        module_id: '',
        x_axis: '',
        y_axis: '',
        time_period: '',
        card_name: ''
      }
      this.statCreationPayload = {
        is_enabled: null,
        module_id: '',
        time_period: '',
        card_name: '',
        parent_option_id: null,
        option_id: null,
        price_range: [100, 500],
        value_for: 1
      }
      this.stats = []
    }
  }
}
</script>
<style scoped>
  .vertical-divider {
    background-color: rgba(0, 0, 0, 0.1);
    width: 1px;
    position: relative;
    margin-left: 50px;
    margin-right: 50px;
  }

  .vertical-divider:after {
    content: 'OR';
    width: 50px;
    height: 50px;
    font-weight: bold;
    border-radius: 50%;
    background-color: rgb(var(--vs-primary));
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .create-option {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    min-width: 220px;
    min-height: 125px;
  }

  .preview-button {
    cursor: pointer;
  }

  .preview-button:hover {
    color: rgb(var(--vs-primary));
  }

  .modal-slider {
    min-width: 250px !important;
  }
  @media (max-width: 1024px) {
    .vertical-divider {
      margin: 40px auto;
      visibility: hidden;
    }
  }
</style>
<style>
.preview_dashboard_modal .graph_preview_holder > div {
  width: 100% !important;
}
.customRadio.custom_container .icon {
  font-size: 80px;
  color: rgb(var(--vs-secondary));
}
</style>